import { SidePanel, SidePanel2 } from '../survey-models/side-panel.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { QuestionModel, PipeOptions } from '../survey-models/question.model';
import { ApiRequestService } from 'src/app/services/api-request/api-request.service';



@Injectable({
    providedIn: 'root'
})
export class surveyPanelService {

    // public ADD_Question: string = environment.apiUrl + '/v2/api/addsQuestion';
    // public Update_Question: string = environment.apiUrl + '/v2/api/updatesQuestion';
    // public Delete_Question: string = environment.apiUrl + '/v2/api/removeEntry';
    // public Update_Question_Position:string = environment.apiUrl +'/v2/updateSequence'

    // public addSurvey: string = environment.apiUrl + '/v2/api/survey/create';
    // public UpdateSurvey: string = environment.apiUrl + '/v2/api/survey';
    
    // public getSurveyById: string = environment.apiUrl + '/v2/api/survey/getByid/';
    // public getQuestionAlls: string = environment.apiUrl + '/v2/api/getQuestionAlls/';
    // public allServeyApi:string=environment.apiUrl +'/v2/api/ssurvey/get';
    // public encryptPrevLink:string=environment.apiUrl +'/v2/api/survey/EncryptPrevLink';
    // public localization:string=environment.apiUrl +'/v2/api/survey/localization';
    // public localizationcsv:string= environment.apiUrl+'/v2/api/survey-localization';

    // public csvuploadUrl:string=environment.apiUrl +'/v2/api/survey-localization-update';

    // public ADD_Question: string = '/v2/api/addsQuestion';
    // public Update_Question: string = '/v2/api/updatesQuestion';
    public Delete_Question: string = '/v2/api/removeEntry';
    public Update_Question_Position:string = '/v2/updateSequence'

    public addSurvey: string = '/v2/api/survey/create';
    public UpdateSurvey: string = '/v2/api/survey';
    
    public getSurveyById: string = '/v2/api/survey/getByid';
    public getQuestionAlls: string = '/v2/api/getQuestionAlls';
    public allServeyApi:string= '/v2/api/ssurvey/get';
    public encryptPrevLink:string= '/v2/api/survey/EncryptPrevLink';
    public localization:string= '/v2/api/survey/localization';
    public localizationcsv:string= '/v2/api/survey-localization';

    public csvuploadUrl:string= '/v2/api/survey-localization-update';

    




    public sidePanel: SidePanel[] = [];
    public subSidePanel: SidePanel2[] = [];
    public pipeoptions: any;

    constructor(private http: HttpClient, private apiRequest: ApiRequestService) {

        this.sidePanel = [{
            "name": "Edit Survey",
            "id": "asd",
            "position": 0,
            "link": '/survey-panel-rest',
            "image": "../../assets/images/xxhdpi/Create.png"
        },
        {
            "name": "Quota",
            "id": "asd",
            "position": 0,
            "link": '/quota-panel',
            "image": "../../assets/images/xxhdpi/Quota.png"
        },
        {
            "name": "Container",
            "id": "asd",
            "position": 0,
            "link": '/container-panel',
            "image": "../../assets/images/xxhdpi/Container.png"
        }];

        this.subSidePanel = [{
            "name": "Add Question",
            "id": "1",
            "position": 1,
            "link": '',
            "image": "",
            "subnav": [
                {
                    "name": "Multiple Choice",
                    "id": "2",
                    "position": 2,
                    "image": "../../assets/images/xxxhdpi/multiple_choice1.png",
                    "GenericId":null

                },
                {
                    "name": "Grid",
                    "id": "12",
                    "position": 12,
                    "image": "../../assets/images/xxxhdpi/grid1.png",
                    "GenericId":null

                },
                {
                    "name": "Rating",
                    "id": "13",
                    "position": 13,
                    "image": "../../assets/images/xxxhdpi/rating1.png",
                    "GenericId":null

                },
                {
                    "name": "Ranking",
                    "id": "14",
                    "position": 14,
                    "image": "../../assets/images/xxxhdpi/ranking1.png",
                    "GenericId":null

                },
                {
                    "name": "Open Text",
                    "id": "4",
                    "position": 4,
                    "image": "../../assets/images/xxxhdpi/open_text1.png",
                    "GenericId":null

                },
                {
                    "name": "Calendar",
                    "id": "16",
                    "position": 16,
                    "image": "../../assets/images/xxxhdpi/calendar1.png",
                    "GenericId":null

                },
                {
                    "name": "Drag And Drop",
                    "id": "17",
                    "position": 17,
                    "image": "../../assets/images/xxxhdpi/drag_drop1.png",
                    "GenericId":null

                },
                {
                    "name": "Add Media",
                    "id": "18",
                    "position": 18,
                    "image": "../../assets/images/xxxhdpi/add_media1.png",
                    "GenericId":null

                },
                {
                    "name": "Agreement",
                    "id": "19",
                    "position": 19,
                    "image": "../../assets/images/xxxhdpi/agreement1.png",
                    "GenericId":null

                },
                {
                    "name": "Face Recognition",
                    "id": "20",
                    "position": 20,
                    "image": "../../assets/images/xxxhdpi/face_recognition1.png",
                    "GenericId":null

                }]
        },
        {
            "name": " Template Question",
            "id": "2",
            "position": 1,
            "link": '',
            "image": "../../assets/images/xxhdpi/add_media.png",
            "subnav": [
                {
                    "name": "Gender",
                    "id": "2",
                    "position": 2,
                    "image": "../../assets/images/temp_ques/gender.png",
                    "GenericId": "Gender"

                },
                {
                    "name": "Age",
                    "id": "12",
                    "position": 12,
                    "image": "../../assets/images/temp_ques/age.png",
                    "GenericId":"Age"

                },
                {
                    "name": "SEC",
                    "id": "13",
                    "position": 13,
                    "image": "../../assets/images/temp_ques/sec.png",
                    "GenericId":"SEC"

                },
                {
                    "name": "OLD SEC",
                    "id": "14",
                    "position": 14,
                    "image": "../../assets/images/temp_ques/oldsec.png",
                    "GenericId":"OLD_SEC"

                },
                {
                    "name": "M-LSM",
                    "id": "4",
                    "position": 4,
                    "image": "../../assets/images/temp_ques/mlsm.png",
                    "GenericId":"M_LSM"

                },
                {
                    "name": "OLD F-LSM",
                    "id": "16",
                    "position": 16,
                    "image": "../../assets/images/temp_ques/flsm.png",
                    "GenericId": "OLD_F_LSM",

                },
                {
                    "name": "NEW F-LSM",
                    "id": "17",
                    "position": 17,
                    "image": "../../assets/images/temp_ques/newflsm.png",
                    "GenericId":"New_F_LSM"

                },
                {
                    "name": "Monthly Income",
                    "id": "18",
                    "position": 18,
                    "image": "../../assets/images/temp_ques/monthlyincome.png",
                    "GenericId": "Monthly_Income"

                },
                {
                    "name": "Marital Status",
                    "id": "19",
                    "position": 19,
                    "image": "../../assets/images/temp_ques/maritalstatus.png",
                    "GenericId": "Marital_Status"

                },
                {
                    "name": "Household Income",
                    "id": "20",
                    "position": 20,
                    "image": "../../assets/images/temp_ques/householdincome.png",
                    "GenericId":"Household_Income"

                },
                {
                    "name": "Family Members",
                    "id": "20",
                    "position": 20,
                    "image": "../../assets/images/temp_ques/familymembers.png",
                    "GenericId":"Family_Members"

                },
                {
                    "name": "No of Child",
                    "id": "20",
                    "position": 20,
                    "image": "../../assets/images/temp_ques/no.ofchild.png",
                    "GenericId":"No_of_child"

                },
                {
                    "name": "Age of Children",
                    "id": "20",
                    "position": 20,
                    "image": "../../assets/images/temp_ques/ageofchildren.png",
                    "GenericId":"Age_of_Children"

                },
                {
                    "name": "Working Status",
                    "id": "20",
                    "position": 20,
                    "image": "../../assets/images/temp_ques/workingstatus.png",
                    "GenericId":"Working_Status",

                },
                {
                    "name": "City",
                    "id": "20",
                    "position": 20,
                    "image": "../../assets/images/temp_ques/city.png",
                    "GenericId":"City"

                },
                // {
                //     "name": "Language",
                //     "id": "2",
                //     "position": 20,
                //     "image": "../../assets/images/temp_ques/language.png",
                //     "GenericId":"Language"

                // },
                {
                    "name": "S-LSM",
                    "id": "20",
                    "position": 20,
                    "image": "../../assets/images/temp_ques/slsm.png",
                    "GenericId": "S_LSM"

                }]
        },
        {
            "name": "Add Logic",
            "id": "3",
            "position": 1,
            "link": '',
            "image": "../../assets/images/xxhdpi/add_media.png",
            "subnav": [     {
                "name": "S-LSM",
                "id": "20",
                "position": 20,
                "image": "../../assets/images/temp_ques/language.png",
                "GenericId":null

            }]

        },
        {
            "name": "Add Screen",
            "id": "4",
            "position": 1,
            "link": '',
            "image": "../../assets/images/xxhdpi/add_media.png",
            "subnav": [     {
                "name": "S-LSM",
                "id": "20",
                "position": 20,
                "image": "../../assets/images/temp_ques/language.png",
                "GenericId":null

            }]

        },
        {
            "name": "Eagle View",
            "id": "52",
            "position": 1,
            "link": '',
            "image": "../../assets/images/xxhdpi/add_media.png",
            "subnav": [     {
                "name": "S-LSM",
                "id": "20",
                "position": 20,
                "image": "../../assets/images/temp_ques/language.png",
                "GenericId":null

            }]

        }];
    }



    // Header for authentication
    httpPostOptions = {
        headers: new HttpHeaders().set('Content-Type', 'application/json'),
        params: new HttpParams(),
        withCredentials: true
    };

    //Header Authentication for file type request
    httpPostOptionsBulk = {
        withCredentials: true
    };

   /* Post API */


    addQuestion(questionDetails: any) {
        return
        // return this.apiRequest.request('POST',this.ADD_Question,questionDetails);
    // return this.http.post(this.ADD_Question, questionDetails, this.httpPostOptions);
    }
    updateQuestion(sData: any) {
        return
        // return this.apiRequest.request('PUT',this.Update_Question,sData);
    // return this.http.put(this.Update_Question, sData, this.httpPostOptions);
    }

    deleteQuestion(sData: any) {
        return this.apiRequest.request('POST',this.Delete_Question,sData);
    // return this.http.post(this.Delete_Question, sData, this.httpPostOptions);
    }
    getAllServeys(sData){
        return this.apiRequest.request('POST',this.allServeyApi,sData);
        // return this.http.post(this.allServeyApi,sData,this.httpPostOptions)

    }

    getEncryptedPrevLink(sLinkdata){
        return this.apiRequest.request('POST',this.encryptPrevLink,sLinkdata);
        // return this.http.post(this.encryptPrevLink, sLinkdata, this.httpPostOptions);
     }

    createSurvey(sData) {
        return this.apiRequest.request('POST',this.addSurvey,sData);
        // return this.http.post(this.addSurvey, sData, this.httpPostOptions);
    }
    updateSurvey(sData) {
        return this.apiRequest.request('PUT',this.UpdateSurvey,sData);
        // return this.http.put(this.UpdateSurvey, sData, this.httpPostOptions);
    }

    updateQuestionPostion(qData){
        return this.apiRequest.request('POST',this.Update_Question_Position,qData);
    //   return this.http.post(this.Update_Question_Position,qData,this.httpPostOptions);
    }


    /* GEt API */
    getSurvey(sid: number) {
        let pathUrl = this.getSurveyById + '/' + sid
        return this.apiRequest.request('GET',pathUrl);
        // return this.http.get(this.getSurveyById + sid, this.httpPostOptions);
    }


    getAllQuestionById(sid: number) {
        let pathUrl = this.getQuestionAlls + '/' + sid
        return this.apiRequest.request('GET',pathUrl);
        // return this.http.get(this.getQuestionAlls + sid, this.httpPostOptions);
    }

    getLocalization(){
        return this.apiRequest.request('GET',this.localization);
        // return this.http.get(this.localization, this.httpPostOptions);

    }


    getLocalizationCsv(api_survey_id) {
        let opt = {}
        opt['httpOptions'] = this.httpPostOptionsBulk
        let pathUrl = this.localizationcsv + '/' + api_survey_id
        return this.apiRequest.request('GET',pathUrl,{},opt);
        // return this.http.get(this.localizationcsv + '/' + api_survey_id, this.httpPostOptionsBulk);

    }


  languageCsvUplaod( csv,surveyid) {
    let input = new FormData();
    input.append('file', csv, csv.name);
    
    let opt = {}
    opt['httpOptions'] = this.httpPostOptionsBulk
    let pathUrl = this.csvuploadUrl + '/' + surveyid
    return this.apiRequest.request('POST',pathUrl,input,opt);
    // return this.http.post<any>(this.csvuploadUrl + '/' + surveyid, input, this.httpPostOptionsBulk);

  }

  



}
